import React from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import TimeRangeDisplay from "views/components/time-range-picker/TimeRangeDisplay";
import TimeRangeSelectInput from "data-lake/components/TimeRangeSelectInput";
const StyledP = styled.p`
  margin-top: 10px;
  font-weight: bold;
`;
const TimeRangeField = ({ submitButtonText, hourOnly }) => {
  const {
    values: { nextTimeRange }
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledP, null, "Time Range: "), /* @__PURE__ */ React.createElement("p", null, "Please select a time range and click ", submitButtonText, "."), /* @__PURE__ */ React.createElement(TimeRangeDisplay, { timerange: nextTimeRange, centerTimestamps: true }), /* @__PURE__ */ React.createElement(TimeRangeSelectInput, { timerange: nextTimeRange, disableTimeMinute: hourOnly, disableTimeSecond: hourOnly }));
};
export default TimeRangeField;
